/**
 * Created by RaoMeng on 2020/10/30
 * Desc: 拜访申请
 */

import React, { Component } from 'react'
import { visitApplyBill } from '../../json/visitApplyBill'
import { getFormAndGrid, getFormItems } from '../../utils/form.util'
import './visitorRegister.css'
import {
  List,
  Button,
  Toast,
} from 'antd-mobile'
import { fetchGet, fetchPost, fetchPostObj } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import { switchUser } from '../../redux/actions/userInfo'
import { Icon, message } from 'antd'
import { clearListState } from '../../redux/actions/listState'
import {getIntValue, getStrValue, isObjNull } from '../../utils/common'
export default class VisitApply extends Component {

  constructor () {
    super()

    this.state = {
      billGroupModelList: [],
      courseList: [],
      courseValue: [],
    }
  }

  componentDidMount () {
    document.title = '拜访申请'
    clearListState()()
    this.searchParams = getSearchParams(this.props.location.search)
    let visitBill = visitApplyBill()
    this.setState({
      billGroupModelList: visitBill,
    }, () => {
      this.getUserInfo()
      this.getOrganization()
    })
  }

  componentWillUnmount () {

  }
  getOrganization = () => {
   const { billGroupModelList } = this.state
        Toast.loading('', 0)
        fetchGet(API.VISIT_RECORD_TEACHER, {
            openid: this.searchParams.openid,
            appId: this.searchParams.appId,
        }).then(response => {
            Toast.hide()

            const {courseList, courseValue} = this.state
            courseList.length = 0
            courseValue.length = 0

            if (response && response.data) {
                // const schoolArray = response.data.schools
                const teacherArray = response.data

                if (!isObjEmpty(teacherArray)) {

                    teacherArray.forEach((teacherObj, index) => {
                        if (teacherObj) {
                            courseList.push({
                                label: getStrValue(teacherObj, 'teacherName'),
                                value: getStrValue(teacherObj, 'teacherId'),
                                //userId: getIntValue(teacherObj, 'teacherId'),
                                //userPhone: getStrValue(teacherObj, 'userPhone'),

                            })
                        }
                    })
                    if (!isObjEmpty(billGroupModelList[0].showBillFields)) {
                        billGroupModelList[0].showBillFields.map(item => {
                        if (item.field === 'objectName') {
                          item.courseList = courseList
                        }
                      })
                    }

                    if (courseList.length > 0) {
                        courseValue.push(courseList[0].value)
                        this.setState({
                            courseList,
                            courseValue
                        })
                    }
                }
            }

            console.log('courseList', courseList)

        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

  render () {
    const formItems = getFormItems(this.state.billGroupModelList)
    return (
      <div className='visit-apply-root'>
        <div className='visit-apply-root' style={{ flex: 1 }}>
          <List>
            {formItems}
          </List>
        </div>
        {formItems.length > 0 &&
        <Button type={'primary'}
                style={{
                  margin: '24px 26px',
                  height: '38px',
                  lineHeight: '38px',
                  fontSize: '16px',
                }}
                onClick={this.onSubmitClick}>提交拜访申请</Button>}

        <Icon type="menu"
              className='common-add-icon'
              style={{
                fontSize: '30px',
                padding: '15px',
                color: 'white',
                background: ' #3db1af',
                borderRadius: '50%',
              }}
              onClick={this.toVisitList}/>
      </div>
    )
  }

  onSubmitClick = () => {
    const { billGroupModelList } = this.state
    let formAndGrid = getFormAndGrid(billGroupModelList)
    if (formAndGrid == null) {
      return
    }
    Toast.loading('正在提交申请...', 0)
    fetchPostObj(API.VISIT_RECORD_APPLY
      , formAndGrid.form, {
        'Content-Type': 'application/json',
      }).then(response => {
      Toast.hide()
      message.success('申请提交成功')
      this.props.history.push('/visitDetail/' + response.data)
    }).catch(error => {
      Toast.hide()
      if (typeof error === 'string') {
        Toast.fail(error, 2)
      } else {
        Toast.fail('提交申请异常')
      }
    })
  }

  getUserInfo = () => {
    if (isObjEmpty(this.searchParams.openid, this.searchParams.appId)) {
      Toast.fail('参数缺失')
    } else {
      /*switchUser({
        appId: this.searchParams.appId,
        userOpenid: this.searchParams.openid,
      })()*/
      const { billGroupModelList } = this.state
      Toast.loading('请求身份信息..', 0)
      fetchGet(API.VISIT_RECORD_USER_INFO, {
        openid: this.searchParams.openid,
        appId: this.searchParams.appId,
      }).then(response => {
        Toast.hide()
        if (isObjEmpty(response) || isObjEmpty(response.data)) {
          if (!isObjEmpty(billGroupModelList[0].hideBillFields)) {
            billGroupModelList[0].hideBillFields.map(item => {
              if (item.field === 'openid') {
                item.value = this.searchParams.openid
              } else if (item.field === 'appId') {
                item.value = this.searchParams.appId
              }
            })
          }
        } else {
          const resData = response.data
          if (!isObjEmpty(billGroupModelList[0].hideBillFields)) {
            billGroupModelList[0].hideBillFields.map(item => {
              if (item.field === 'openid') {
                item.value = resData.openid
              } else if (item.field === 'appId') {
                item.value = this.searchParams.appId
              } else if (item.field === 'visitorId') {
                item.value = resData.id
              } else if (item.field === 'schoolId') {
                item.value = resData.schoolId
              }
            })
          }

          if (!isObjEmpty(billGroupModelList[0].showBillFields)) {
            billGroupModelList[0].showBillFields.map(item => {
              if (item.field === 'name') {
                item.value = resData.name
              } else if (item.field === 'idCard') {
                item.value = resData.idCard
              } else if (item.field === 'mobile') {
                item.value = resData.mobile
              }
            })
          }
        }
        this.setState({ billGroupModelList })
      }).catch(error => {
        Toast.hide()
        if (typeof error === 'string') {
          Toast.fail(error, 2)
        } else {
          Toast.fail('身份信息获取异常')
        }
      })
    }
  }

  toVisitList = () => {
    this.props.history.push(
      '/visitList?openid=' + this.searchParams.openid + '&appId=' +
      this.searchParams.appId)
  }
}
